import { Toaster as HotToaster } from 'react-hot-toast';
import { useTheme } from '@/theme/ThemeProvider';

export function Toaster() {
  const { theme } = useTheme();

 return (
    <HotToaster
      position="top-center"
      reverseOrder={false}
      gutter={12}
      containerStyle={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2147483647,
        pointerEvents: 'none',
      }}
      toastOptions={{
        duration: 4000,


        style: {
          minWidth: '320px',
          maxWidth: '90vw',
          backgroundColor: '#ffffff', 
          color: '#0f172a',
          opacity: 1,                
          borderRadius: '10px',
          border: '1px solid #e5e7eb',
          padding: '12px 16px',
          fontSize: '14px',
          fontWeight: 500,
          boxShadow: '0 12px 30px rgba(0,0,0,0.18)',
        },

        success: {
          style: {
            backgroundColor: '#ffffff',
            border: '1px solid #10b981',
            opacity: 1,
          },
          iconTheme: {
            primary: '#10b981',
            secondary: '#ffffff',
          },
        },

        error: {
          duration: 5000,
          style: {
            backgroundColor: '#ffffff',
            border: '1px solid #ef4444',
            opacity: 1,
          },
          iconTheme: {
            primary: '#ef4444',
            secondary: '#ffffff',
          },
        },
      }}
    />
  );
}